import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { valueToPercent } from '../helpers';
import { useSliderValueState } from './useSliderValueState';
import { useMouseTouchController } from './useMouseTouchController';
import { useSliderMarks } from './useSliderMarks';
import { useSliderValueThumbs } from './useSliderValueThumbs';
import { useSliderHelpers } from './useSliderHelpers';
export function useSliderController(props) {
  var min = props.min,
      max = props.max;
  var sliderRef = React.useRef(null);
  var marks = useSliderMarks(props);
  var valueState = useSliderValueState(props);

  var _useSliderHelpers = useSliderHelpers({
    props: props,
    marks: marks
  }),
      roundValue = _useSliderHelpers.roundValue;

  var _useSliderValueThumbs = useSliderValueThumbs({
    props: props,
    valueState: valueState,
    marks: marks
  }),
      handleThumbsSliderRef = _useSliderValueThumbs.sliderRef,
      thumbs = _useSliderValueThumbs.thumbs,
      setFocusIndex = _useSliderValueThumbs.setFocusIndex,
      setActiveIndex = _useSliderValueThumbs.setActiveIndex,
      setOpenIndex = _useSliderValueThumbs.setOpenIndex;

  var range = valueState.range,
      values = valueState.values;

  var _useMouseTouchControl = useMouseTouchController({
    props: props,
    valueState: valueState,
    sliderRef: sliderRef,
    setFocusIndex: setFocusIndex,
    setActiveIndex: setActiveIndex,
    setOpenIndex: setOpenIndex,
    roundValue: roundValue
  }),
      onMouseDown = _useMouseTouchControl.onMouseDown;

  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
  var handleSliderRef = useForkRef(sliderRef, handleThumbsSliderRef);
  return {
    sliderRef: handleSliderRef,
    trackOffset: trackOffset,
    trackLeap: trackLeap,
    valueState: valueState,
    onMouseDown: onMouseDown,
    thumbs: thumbs,
    marks: marks
  };
}